export default "__VITE_ASSET__ad93db3c__"